<div class="row ms-1">
    <div class="col-lg-3">
        <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#viewSaveClientAuth"
            [disabled]="global.viewTabs" (click)="PlusAuthorization()" *ngIf="fp.authorizationcreate">Add
            Authorization</button>
    </div>
    <div class="col-lg-3">
        <div class="row">
            <div class="col-lg-3">
                <span>Status&nbsp;</span>
            </div>
            <div class="col-lg-8">
                <ng-select class="w-100" (change)="getAuthorizationdata()" [(ngModel)]="AuthFilter"
                    [disabled]="global.viewTabs" style="color: black;" [clearable]="false" [searchable]="true"
                    [items]="FilterList" bindLabel="authnames" bindValue="authid">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="col-lg-3">
        <div class="row">
            <div class="col-lg-3">
            </div>
            <div class="col-lg-8">
                <button type="button" class="btn blue-btn btn-sm" [disabled]="global.viewTabs"
                    (click)="RefreshFilter()">Refresh</button>
            </div>
        </div>
    </div>
</div>
<div class="row mb-2">
    <div class="col mt-1">
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <!-- ejs-grid -->
                <ejs-grid #gridClientAuthorization [dataSource]='GridList | async' [allowPaging]='true'
                    [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                    [allowResizing]='true' [showColumnChooser]='true' [allowSorting]='true'
                    (dataStateChange)='dataChangeAuthorization($event)' (actionBegin)="onActionAuthorization($event)">
                    <e-columns>
                        <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                            <ng-template #template let-data>
                                <button class="btn btn-edit-table" data-bs-toggle="modal"
                                    [disabled]="global.viewTabs || data.budgetId!=null && data.budgetId!=undefined && data.budgetId!='' "
                                    data-bs-target="#viewUpdateClientAuth" (click)="getDetails(data)"
                                    *ngIf="fp.authorizationupdate"><i class="fa fa-edit"></i></button>&nbsp;
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="companyName" headerText="Company Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="startDate" headerText="Start Date" type="date"
                            [allowFiltering]='false' [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>

                        <e-column minWidth=100 field="endDate" headerText="End Date" [format]='formatOptions'
                            [allowFiltering]='false' type="date">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>

                        <e-column minWidth=100 field="payorName" headerText="Payer Name" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="authTypeName" headerText="Auth Type" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="serviceCode" headerText="Service Code" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="authNote" headerText="AuthNote" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>

                        <e-column minWidth=100 field="rate" headerText="Rate" type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                       <e-column minWidth=100 field="totalHoursCalculated" headerText="Total Hours" type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="totalNoWeeksOrMonths" headerText="Total No of weeks"
                            type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="totalAmt" headerText="Total Amount" type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="usedAmt" headerText="Used Amount" type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="totalhours" headerText="Total Hours / Week" type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="remainingAmt" headerText="Remaining Amount" type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth="120" field="totalRemainingHours" headerText="Remaining Hours" type="number" [allowFiltering]="false" [allowSorting]="false">
                        </e-column>
                        <e-column minWidth=100 field="totalRemainingHoursPerDay" headerText="Remaining Hours per Day" type="number" [allowFiltering]="false" [allowSorting]="false">
                        </e-column>
                        <e-column minWidth=100 field="totalRemainingHoursPerWeek" headerText="Remaining Hours per Week" type="number" [allowFiltering]="false" [allowSorting]="false">
                        </e-column>
                        <e-column minWidth=100 field="insuranceNumber" headerText="Insurance Number" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="serviceAgreementNumber" headerText="Service Agreement Number"
                            type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="icD10Code" headerText="ICD10 Code" type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <e-column minWidth=100 field="isTaxable" headerText="Is Taxable" type="boolean">
                            <ng-template #filterTemplate let-data>
                                <ejs-dropdownlist id='dropdata3'
                                placeholder='Select Status'
                                [dataSource]='dropdatas'
                                [popupHeight]='height'></ejs-dropdownlist>
                              </ng-template>
                        </e-column>
                        <e-column width="50" [showInColumnChooser]='false'>
                            <ng-template #headerTemplate let-data>
                                <div>
                                    <span id='show' (click)='showAuthColumns()'><i class="fa fa-cog fa-lg"
                                            aria-hidden="true">
                                        </i></span>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</div>
<!-- New Authorization -->
<span id="openSaveModal" data-bs-toggle="modal" data-bs-target="#viewSaveClientAuth"></span>
<div class="modal  fade" id="viewSaveClientAuth" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog mw-100">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    New Authorization </h5>
            </div>
            <div class="modal-body">
                <div *ngFor="let authitems of SaveClientAuthList;let AuthorizationIndex=index">
                    <div class="row">
                        <!-- Start Date -->
                        <div class="col-lg-2">
                            <label>Start Date
                                <sup class="super-script">&nbsp;*</sup>
                            </label>
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="authitems.startDate"
                                (inputFieldChanged)="DateFormat($event,'inputchanged','SaveStartDate',AuthorizationIndex)"
                                (dateChanged)="DateFormat($event,'datechanged','SaveStartDate',AuthorizationIndex)"
                                placeholder="mm/dd/yyyy">
                            </my-date-picker>
                        </div>
                        <!-- End Date -->
                        <div class="col-lg-2">
                            <label>End Date
                                <sup class="super-script">&nbsp;*</sup>
                            </label>
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="authitems.endDate"
                                (inputFieldChanged)="DateFormat($event,'inputchanged','SaveEndDate',AuthorizationIndex)"
                                (dateChanged)="DateFormat($event,'datechanged','SaveEndDate',AuthorizationIndex)"
                                placeholder="mm/dd/yyyy">
                            </my-date-picker>
                        </div>
                        <!-- Payer -->
                        <div class="col-lg-2">
                            <label>Payer
                                <sup class="super-script">&nbsp;*</sup>
                            </label>
                            <ng-select [clearable]="true" [searchable]="true" [items]="PayerList"
                                [(ngModel)]="authitems.groupPayorId" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                        <!-- Auth type -->
                        <div class="col-lg-3">
                            <label>
                                Auth type
                                <sup class="super-script">&nbsp;*</sup></label>
                            <ng-select [clearable]="true" [searchable]="true" [items]="AuthTypeList"
                                [(ngModel)]="authitems.authTypelid"
                                (ngModelChange)="servicebasedAuthforNewAuthorization(authitems,AuthorizationIndex)"
                                bindLabel="lovCode" bindValue="id">
                            </ng-select>
                        </div>
                        <!-- Service -->
                        <div class="col-lg-3">
                            <label>Service
                                <sup class="super-script">&nbsp;*</sup>
                            </label>
                            <ng-select [clearable]="true" [(ngModel)]="authitems.serviceId"
                                [items]="authitems.ServiceArrayList" bindLabel="Value"
                                [disabled]="authitems.authTypelid==null || authitems.authTypelid==undefined || authitems.authTypelid==''"
                                bindValue="Key">
                            </ng-select>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-10">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label> Insurance No
                                        <sup class="super-script">&nbsp;*</sup></label>
                                    <input type="text" class="form-control w-100"
                                        [(ngModel)]="authitems.insuranceNumber">
                                </div>
                                <div class="col-lg-2">
                                    <label>Auth Note</label>
                                    <input type="text" class="form-control w-100" [(ngModel)]="authitems.authNote">
                                </div>
                                <div class="col-lg-2">
                                    <label> Company
                                        <sup class="super-script">&nbsp;*</sup></label>
                                    <ng-select [(ngModel)]="authitems.companyId" [items]="companyList" bindLabel="Value"
                                        bindValue="Key"></ng-select>
                                </div>
                                <div class="col-lg-2">
                                    <label> Service Agreement No
                                    </label>
                                    <input type="text" [(ngModel)]="authitems.serviceAgreementNumber"
                                        class="form-control">

                                </div>
                                <div class="col-lg-2">
                                    <label> ICD10
                                    </label>
                                    <div class="d-flex">
                                        <input type="text" [(ngModel)]="authitems.icD10Code" class="form-control"
                                            disabled>
                                        <button class="btn btn-sm btn-primary btn-edit-table icd10-btn ms-2"
                                            data-bs-target="#ICD10" data-bs-toggle="modal"
                                            (click)="enableICD10=true; getAuthIndex(AuthorizationIndex)">
                                            <i class="fa fa fa-eye" id="ICD10Eye"></i></button>
                                    </div>
                                </div>


                                <div class="col-lg-2">
                                    <label> Taxable
                                    </label> &nbsp;
                                    <input type="checkbox" [(ngModel)]="authitems.isTaxable"
                                        (change)="taxchange($event,authitems.isTaxable)">
                                </div>

                            </div>

                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-10">
                            <div class="row">
                                <!-- Rate -->
                                <div class="col-lg-3">
                                    <label> Rate
                                        <sup class="super-script">&nbsp;*</sup>
                                    </label>
                                    <input type="number" class="form-control w-100" [(ngModel)]="authitems.rate"
                                        (ngModelChange)="CalculateTotalAmount(authitems,'save');"
                                        (keypress)="keyPressForDecimal($event)" min="0">
                                </div>
                                <!-- Total Hours -->
                                <div class="col-lg-3">
                                    <label>Total Hours / Week
                                        <sup class="super-script">&nbsp;*</sup></label>
                                    <input type="number" class="form-control w-100" [(ngModel)]="authitems.totalhours"
                                        (ngModelChange)="CalculateTotalAmount(authitems,'save');"
                                        (keypress)="allowonlyInteger($event)" min="0">
                                </div>
                                <!-- Total number of weeks -->
                                <div class="col-lg-2">
                                    <label> Total number of weeks
                                        <sup class="super-script">&nbsp;*</sup></label>
                                    <input type="number" class="form-control w-100"
                                        [(ngModel)]="authitems.totalNoWeeksOrMonths"
                                        (ngModelChange)="CalculateTotalAmount(authitems,'save');"
                                        (keypress)="allowonlyInteger($event)" min="0">
                                </div>
                                <!-- Total Amount -->
                                <div class="col-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <label>Total Amount <sup class="super-script">&nbsp;*</sup></label>
                                            <input type="text" class="form-control w-100" disabled
                                                [(ngModel)]="authitems.usedAmt">
                                        </div>



                                        <div class="col-lg-8 mt-4">

                                            <button class="btn btn-sm btn-sm ml-3" (click)="PlusAuthorization()"> <i
                                                    class="fa fa-plus" aria-hidden="true"></i></button>&nbsp;
                                            <button class="btn btn-danger btn-sm ml-3"
                                                (click)="removeAuthorization(AuthorizationIndex)"
                                                *ngIf="AuthorizationIndex!=0">
                                                <i class="fa fa-times"></i></button>&nbsp;
                                            <button class="btn btn-danger btn-sm ml-1"
                                                (click)="clearAuthorization(AuthorizationIndex)">Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="isDisabled"
                    (click)="CheckClientAuthorizationValidation(SaveClientAuthList)"> Save &
                    Close</button>
                <button type="button" class="btn btn-sm " data-bs-dismiss="modal" (click)="clearModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- for update -->
<span id="openUpdateModal" data-bs-toggle="modal" data-bs-target="#viewUpdateClientAuth"></span>
<div class="modal  fade" id="viewUpdateClientAuth" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    Update Authorization </h5>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-lg-6">
                        <div class="mt-3 row" [formGroup]="UpdateAuthForm">
                            <!-- Start Date -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Start Date
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <my-date-picker [options]="myDatePickerOptions"
                                    [selDate]="saveAuthorizationInfo.startDate" disabled class="Not"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','UpdateStartDate',0)"
                                    (dateChanged)="DateFormat($event,'datechanged','UpdateStartDate',0)"
                                    formControlName="updatestartDate" placeholder="mm/dd/yyyy">
                                </my-date-picker>
                            </div>
                        </div>
                        <div class="mt-3 row" [formGroup]="UpdateAuthForm">
                            <!-- End Date -->
                            <div class="col-lg-5">
                                <label class="updatelabel">End Date
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <my-date-picker [options]="myDatePickerOptions" disabled class="Not"
                                    [selDate]="saveAuthorizationInfo.endDate"
                                    (inputFieldChanged)="DateFormat($event,'inputchanged','UpdateEndDate',0)"
                                    (dateChanged)="DateFormat($event,'datechanged','UpdateEndDate',0)"
                                    formControlName="updateendDate" placeholder="mm/dd/yyyy">
                                </my-date-picker>
                            </div>
                        </div>

                        <div class="mt-3 row" [formGroup]="UpdateAuthForm">
                            <!-- Payer -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Payer<sup class="super-script">&nbsp;*</sup>&nbsp;</label>
                            </div>
                            <div class="col-lg-7">
                                <ng-select [clearable]="true" [searchable]="true" [items]="PayerList"
                                    [(ngModel)]="saveAuthorizationInfo.groupPayorId" bindLabel="Value" bindValue="Key"
                                    formControlName="updatePayer">
                                </ng-select>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <!-- Auth type -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Auth type <sup class="super-script">&nbsp;*</sup>
                                </label>
                            </div>
                            <div class="col-lg-7">
                                <ng-select [clearable]="false" [searchable]="true" [items]="AuthTypeList"
                                    [(ngModel)]="saveAuthorizationInfo.authTypelid" disabled
                                    (ngModelChange)="ChangeServiceBasedAuth('change')" bindLabel="lovCode"
                                    bindValue="id">
                                </ng-select>
                            </div>
                        </div>
                        <div class="mt-3 row">
                            <!-- Service Code -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Service Code
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <ng-select [clearable]="true" [items]="ServiceBasedAuthType" bindLabel="Value" disabled
                                    [(ngModel)]="saveAuthorizationInfo.serviceId" bindValue="Key">

                                </ng-select>
                            </div>
                        </div>
                        <div class="mt-3 row" [formGroup]="UpdateAuthForm">
                            <!-- Service Code -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Insurance No
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text" class="form-control"
                                    [(ngModel)]="saveAuthorizationInfo.insuranceNumber"
                                    formControlName="updateinsuranceNo"
                                    (input)="UpdateAuthForm.get('updateinsuranceNo')?.setValue($event.target.value.trimStart(), {emitEvent: false})"
                                    >
                                   

<span class="req" *ngIf="UpdateAuthForm.get('updateinsuranceNo')?.invalid "> 

  <p class="text-danger" *ngIf="UpdateAuthForm.get('updateinsuranceNo')?.errors?.['whitespace']">
    Insurance number cannot be empty or just spaces.
  </p>

  <p class="text-danger" *ngIf="UpdateAuthForm.get('updateinsuranceNo')?.errors?.['minlengthtrim']">
    Insurance number must have at least 2 non-space characters.
  </p>
</span>


                            </div>
                        </div>

                        <div class="mt-3 row">
                            <!-- Service Code -->
                            <div class="col-lg-5">
                                <label class="updatelabel">ICD10
                                </label>
                            </div>
                            <div class="col-lg-7 d-flex">
                                <input type="text" class="form-control" [(ngModel)]="saveAuthorizationInfo.icD10Code"
                                    disabled>
                                <button class="btn btn-sm btn-primary btn-edit-table icd10-btn ms-2"
                                    data-bs-target="#ICD10" data-bs-toggle="modal" (click)="enableICD10=true;">
                                    <i class="fa fa fa-eye" id="ICD10Eye"></i></button>
                            </div>
                        </div>
                        <div class="mt-3 row">
                            <!-- Service Code -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Service Agreement NO
                                </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text" class="form-control"
                                    [(ngModel)]="saveAuthorizationInfo.serviceAgreementNumber">
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-6" [formGroup]="UpdateAuthForm">
                        <div class="mt-4 row">
                            <!-- Rate -->
                            <div class="col-lg-5">
                                <label class="updatelabel"> Rate <sup class="super-script">&nbsp;*</sup>
                                </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="number" class="form-control" min="0" [(ngModel)]="saveAuthorizationInfo.rate"
                                    formControlName="updateRate" (ngModelChange)="CalculateTotalAmount('','update');"
                                    (keypress)="keyPressForDecimal($event)">
                            </div>
                        </div>

                        <!-- authnote... -->

                        <div class="mt-4 row" [formGroup]="UpdateAuthForm">
                            <!-- Rate -->
                            <div class="col-lg-5">
                                <label class="updatelabel">AuthNote
                                </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text" class="form-control" [(ngModel)]="saveAuthorizationInfo.authNote"
                                    formControlName="authNote">
                            </div>
                        </div>


                        <div class="mt-4 row">
                            <!-- Total Hours -->
                            <div class="col-lg-5">
                                <label class="updatelabel">Total Hours / Week <sup class="super-script">&nbsp;*</sup>
                                </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="number" class="form-control w-100"
                                    [(ngModel)]="saveAuthorizationInfo.totalhours" min="0" formControlName="updateTotalHours"
                                    (ngModelChange)="CalculateTotalAmount('','update');"
                                    (keypress)="allowonlyInteger($event)">
                            </div>
                        </div>
                        <div class="mt-4 row">
                            <!-- Total number of weeks# -->
                            <div class="col-lg-5">
                                <label class="updatelabel"> Total number of weeks
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <input type="number" class="form-control w-100" min="0"
                                    [(ngModel)]="saveAuthorizationInfo.totalNoWeeksOrMonths"
                                    formControlName="updateTotalnoofweeks"
                                    (ngModelChange)="CalculateTotalAmount('','update');"
                                    (keypress)="allowonlyInteger($event)">
                            </div>
                        </div>
                        <!-- Total Amount -->
                        <div class="mt-4 row">
                            <div class="col-lg-5">
                                <label class="updatelabel">Total Amount
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text" class="form-control w-100" disabled
                                    [(ngModel)]="saveAuthorizationInfo.usedAmt" formControlName="updateTotalAmount">
                            </div>
                        </div>
                        <div class="mt-4 row">
                            <div class="col-lg-5">
                                <label class="updatelabel">Company
                                    <sup class="super-script">&nbsp;*</sup></label>
                            </div>
                            <div class="col-lg-7">
                                <ng-select [clearable]="true" [searchable]="true"
                                    [(ngModel)]="saveAuthorizationInfo.companyId" formControlName="updateCompany"
                                    [items]="companyList" bindLabel="Value" bindValue="Key"></ng-select>

                            </div>
                        </div>
                        <div class="mt-2 row">
                            <div class="col-lg-5">
                                <label class="updatelabel">Taxable
                                </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="checkbox" [(ngModel)]="saveAuthorizationInfo.isTaxable"
                                    formControlName="isTaxable">

                            </div>
                        </div>
                        <div class="mt-4 row">
                            <div class="col-lg-5">
                                <label class="updatelabel">InActive
                                    </label>
                            </div>
                            <div class="col-lg-7">
                               <input type="checkbox" [(ngModel)]="saveAuthorizationInfo.inActive" formControlName="inActive">
                               
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button class="btn btn-sm " (click)="UpdateClientAuth()" [disabled]="UpdateAuthForm.invalid  || isDisabled ">Update &
                    Close
                </button>
                <button type="button" class="btn btn-sm " data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-----------------------------------------------  ICD10       --------------------------------------------------------------->
<span id="ICD10eopen" data-bs-toggle="modal" data-bs-target="#ICD10"></span>
<div class="modal hide fade modalbackgrod" id="ICD10" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="Closedcdialog()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body ml-1">
                <app-icd10 *ngIf="enableICD10" (dataFromICD10)=ICD10data($event) [ICD10input]="ICD10value"></app-icd10>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="Closedcdialog()">Cancel</button>
            </div>
        </div>
    </div>
</div>